import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IWarehouseTransferDetail_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IWarehouseTransferDetail_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromLocalStorage: string;
  ReadFromLocalStorage_dummy: string;
  GetItem: any[];
  GetItem_dummy: any[];
  GetTransferLineByHeader: any[];
  GetTransferLineByHeader_dummy: any[];
  HS_TransferLineInsertFromBarcode: any[];
  HS_TransferLineInsertFromBarcode_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  ScanBarcode: string;
  ScanBarcode_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  TransferListForPost: any[];
  TransferListForPost_dummy: any[];
  PostTransfer: any;
  PostTransfer_dummy: any;
  isComp943807Visible: "visible" | "hidden";
  isComp263027Visible: "visible" | "hidden";
  isComp251937Visible: "visible" | "hidden";
  isComp576803Visible: "visible" | "hidden";
  isComp721759Visible: "visible" | "hidden";
  isComp402812Visible: "visible" | "hidden";
  isComp530942Visible: "visible" | "hidden";
  isComp848234Visible: "visible" | "hidden";
  isComp695618Visible: "visible" | "hidden";
  isComp367813Visible: "visible" | "hidden";
  isComp358223Visible: "visible" | "hidden";
  isComp98875Visible: "visible" | "hidden";
}

export class WarehouseTransferDetail_ScreenBase extends React.PureComponent<
  IWarehouseTransferDetail_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  warehousetransferdetail_576320_value_kuikaTableRef: React.RefObject<any>;
  warehousetransferdetail_196727_value_kuikaPaginationRef: React.RefObject<any>;
  warehousetransferdetail_633835_value_kuikaTableRef: React.RefObject<any>;
  warehousetransferdetail_355611_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "fc1f0031-38f1-4719-b558-f0ef651a9e9d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 245868, PropertyName: "value", Value: "Depolar Arası Transfer" },
        { Id: 943807, PropertyName: "tab", Value: "Satırlar" },
        { Id: 553760, PropertyName: "value", Value: "Çıkar/Ekle" },
        { Id: 821407, PropertyName: "value", Value: "Çıkar/Ekle" },
        { Id: 980938, PropertyName: "placeholder", Value: "15" },
        { Id: 656145, PropertyName: "placeholder", Value: "Barkod Giriniz..." },
        { Id: 263027, PropertyName: "value", Value: "Barkod" },
        { Id: 576803, PropertyName: "value", Value: "Barkod Bulunamadı" },
        {
          Id: 721759,
          PropertyName: "value",
          Value: "Henüz sayılmamış üründen çıkarma yapılamaz",
        },
        { Id: 402812, PropertyName: "value", Value: "Eklendi" },
        { Id: 530942, PropertyName: "value", Value: "Çıkartıldı" },
        { Id: 367813, PropertyName: "value", Value: "Kategori" },
        { Id: 358223, PropertyName: "value", Value: "Marka" },
        { Id: 166599, PropertyName: "value", Value: "Önceki Ürün Sayısı" },
        {
          Id: 984815,
          PropertyName: "value",
          Value: "Yeni Eklenen Ürün Sayısı",
        },
        { Id: 669539, PropertyName: "value", Value: "İşlenen Ürün Sayısı" },
        { Id: 117271, PropertyName: "value", Value: "Ürün Ara" },
        { Id: 70262, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 384749, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 881307, PropertyName: "label", Value: "Temizle" },
        { Id: 60849, PropertyName: "label", Value: "Ara" },
        { Id: 889049, PropertyName: "title", Value: "Title" },
        { Id: 314991, PropertyName: "value", Value: "[datafield:itemcode]" },
        {
          Id: 201767,
          PropertyName: "value",
          Value: "[datafield:itemdescription]",
        },
        { Id: 489492, PropertyName: "value", Value: "Kategori" },
        {
          Id: 589172,
          PropertyName: "value",
          Value: "[datafield:productatt01desc]",
        },
        { Id: 791468, PropertyName: "value", Value: "Marka" },
        {
          Id: 835366,
          PropertyName: "value",
          Value: "[datafield:productatt02desc]",
        },
        { Id: 594209, PropertyName: "tab", Value: "Sonuç" },
        { Id: 381242, PropertyName: "value", Value: "Ürün Ara" },
        { Id: 729929, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 593850, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 887885, PropertyName: "label", Value: "Temizle" },
        { Id: 152099, PropertyName: "label", Value: "Ara" },
        { Id: 531425, PropertyName: "label", Value: "NebimV3'e Gönder" },
        { Id: 850099, PropertyName: "title", Value: "Title" },
        { Id: 877028, PropertyName: "value", Value: "[datafield:itemcode]" },
        {
          Id: 955429,
          PropertyName: "value",
          Value: "[datafield:itemdescription]",
        },
        { Id: 158720, PropertyName: "value", Value: "Adet" },
        { Id: 938055, PropertyName: "value", Value: "[datafield:transferqty]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.warehousetransferdetail_656145_value_kuikaTextInputRef =
      React.createRef();
    this.warehousetransferdetail_550531_value_kuikaTextInputRef =
      React.createRef();
    this.warehousetransferdetail_22731_value_kuikaTextInputRef =
      React.createRef();
    this.warehousetransferdetail_576320_value_kuikaTableRef = React.createRef();
    this.warehousetransferdetail_196727_value_kuikaPaginationRef =
      React.createRef();
    this.warehousetransferdetail_301750_value_kuikaTextInputRef =
      React.createRef();
    this.warehousetransferdetail_750687_value_kuikaTextInputRef =
      React.createRef();
    this.warehousetransferdetail_633835_value_kuikaTableRef = React.createRef();
    this.warehousetransferdetail_355611_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      NAVIGATE: "",
      ReadFromLocalStorage: "",
      GetItem: [],
      GetTransferLineByHeader: [],
      HS_TransferLineInsertFromBarcode: [],
      Notify: false,
      ScanBarcode: "",
      SetValueOf: "",
      TransferListForPost: [],
      PostTransfer: "",
      isComp943807Visible: "hidden",
      isComp263027Visible: "hidden",
      isComp251937Visible: "hidden",
      isComp576803Visible: "hidden",
      isComp721759Visible: "hidden",
      isComp402812Visible: "hidden",
      isComp530942Visible: "hidden",
      isComp848234Visible: "hidden",
      isComp695618Visible: "hidden",
      isComp367813Visible: "hidden",
      isComp358223Visible: "hidden",
      isComp98875Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "warehousetransferdetail",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.WarehouseTransferDetailPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.WarehouseTransferDetailPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferdetail",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferdetail",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.WarehouseTransferDetailPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.WarehouseTransferDetailPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      warehousetransferdetail_135272_value: true,
      warehousetransferdetail_980938_value: 1,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  WarehouseTransferDetailPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromLocalStorage =
      await ReactSystemFunctions.readFromLocalStorage(
        ReactSystemFunctions.convertToTypeByName("TransferHeaderId", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WarehouseTransferDetailPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WarehouseTransferDetailPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      ItemCode_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      TransferHeaderId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      SearchItemDescription_1: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      PageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItem = result?.data.getItem;

    stateVars.GetTransferLineByHeader = result?.data.getTransferLineByHeader;

    stateVars.isComp943807Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTransferLineByHeader !== undefined
            ? stateVars.GetTransferLineByHeader?.length > 0
              ? stateVars.GetTransferLineByHeader[0].erpDocumentNo
              : null
            : this.state.GetTransferLineByHeader?.length > 0
            ? this.state.GetTransferLineByHeader[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WarehouseTransferDetailPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp943807Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTransferLineByHeader !== undefined
            ? stateVars.GetTransferLineByHeader?.length > 0
              ? stateVars.GetTransferLineByHeader[0].erpDocumentNo
              : null
            : this.state.GetTransferLineByHeader?.length > 0
            ? this.state.GetTransferLineByHeader[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp263027Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp251937Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp576803Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("BARCODE_NOT_FOUND", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp721759Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp402812Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].operationType
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].operationType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ADD", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_TransferLineInsertFromBarcode !== undefined
              ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
                ? stateVars.HS_TransferLineInsertFromBarcode[0].result
                : null
              : this.state.HS_TransferLineInsertFromBarcode?.length > 0
              ? this.state.HS_TransferLineInsertFromBarcode[0].result
              : null
          ),
          ReactSystemFunctions.convertToTypeByName(
            "BARCODE_NOT_FOUND",
            "string"
          )
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp530942Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_TransferLineInsertFromBarcode !== undefined
              ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
                ? stateVars.HS_TransferLineInsertFromBarcode[0].operationType
                : null
              : this.state.HS_TransferLineInsertFromBarcode?.length > 0
              ? this.state.HS_TransferLineInsertFromBarcode[0].operationType
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("REMOVE", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848234Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp695618Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp367813Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp358223Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp98875Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_576320 = stateVars.GetItem ?? this.state.GetItem;
    formVars.warehousetransferdetail_196727_total = ReactSystemFunctions.value(
      this,
      stateVars.GetItem !== undefined
        ? stateVars.GetItem?.length > 0
          ? stateVars.GetItem[0].totalRowCount
          : null
        : this.state.GetItem?.length > 0
        ? this.state.GetItem[0].totalRowCount
        : null
    );

    stateVars.dataSource_633835 =
      stateVars.GetTransferLineByHeader ?? this.state.GetTransferLineByHeader;
    formVars.warehousetransferdetail_355611_total = ReactSystemFunctions.value(
      this,
      stateVars.GetTransferLineByHeader !== undefined
        ? stateVars.GetTransferLineByHeader?.length > 0
          ? stateVars.GetTransferLineByHeader[0].totalRowCount
          : null
        : this.state.GetTransferLineByHeader?.length > 0
        ? this.state.GetTransferLineByHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_430437_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_407529_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "WarehouseTransferDetail",
      "WarehouseTransferInfo",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "963311",
      null,
      null,
      "true",
      "100%",
      "500px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_656145_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Barcode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_656145_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IsAdd_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_135272_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      TransferQty_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_980938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TransferHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_656145_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.HS_TransferLineInsertFromBarcode =
      result?.data.hS_TransferLineInsertFromBarcode;
    formVars.warehousetransferdetail_251937_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].barcode
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].barcode
          : null
      );
    formVars.warehousetransferdetail_174934_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].itemCode
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].itemCode
          : null
      );
    formVars.warehousetransferdetail_650156_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].itemDescription
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].itemDescription
          : null
      );
    formVars.warehousetransferdetail_902974_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].productAtt01Desc
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].productAtt01Desc
          : null
      );
    formVars.warehousetransferdetail_869192_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].productAtt02Desc
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].productAtt02Desc
          : null
      );
    formVars.warehousetransferdetail_780854_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].previousQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].previousQty
          : null
      );
    formVars.warehousetransferdetail_626780_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].newQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].newQty
          : null
      );
    formVars.warehousetransferdetail_657165_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].appliedQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].appliedQty
          : null
      );
    stateVars.isComp263027Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp251937Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp576803Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("BARCODE_NOT_FOUND", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp721759Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp402812Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].operationType
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].operationType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ADD", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_TransferLineInsertFromBarcode !== undefined
              ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
                ? stateVars.HS_TransferLineInsertFromBarcode[0].result
                : null
              : this.state.HS_TransferLineInsertFromBarcode?.length > 0
              ? this.state.HS_TransferLineInsertFromBarcode[0].result
              : null
          ),
          ReactSystemFunctions.convertToTypeByName(
            "BARCODE_NOT_FOUND",
            "string"
          )
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp530942Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_TransferLineInsertFromBarcode !== undefined
              ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
                ? stateVars.HS_TransferLineInsertFromBarcode[0].operationType
                : null
              : this.state.HS_TransferLineInsertFromBarcode?.length > 0
              ? this.state.HS_TransferLineInsertFromBarcode[0].operationType
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("REMOVE", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848234Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp695618Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp367813Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp358223Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp98875Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_656145_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_656145_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].result
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].result
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    formVars.warehousetransferdetail_251937_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].barcode
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].barcode
          : null
      );

    formVars.warehousetransferdetail_174934_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].itemCode
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].itemCode
          : null
      );

    formVars.warehousetransferdetail_650156_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].itemDescription
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].itemDescription
          : null
      );

    formVars.warehousetransferdetail_902974_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].productAtt01Desc
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].productAtt01Desc
          : null
      );

    formVars.warehousetransferdetail_869192_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].productAtt02Desc
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].productAtt02Desc
          : null
      );

    formVars.warehousetransferdetail_780854_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].previousQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].previousQty
          : null
      );

    formVars.warehousetransferdetail_626780_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].newQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].newQty
          : null
      );

    formVars.warehousetransferdetail_657165_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].appliedQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].appliedQty
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_131297_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ScanBarcode = await ReactSystemFunctions.scanBarcode();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_131297_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_131297_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Barcode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        "string"
      ),
      IsAdd_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_135272_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      TransferQty_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_980938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TransferHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_131297_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.HS_TransferLineInsertFromBarcode =
      result?.data.hS_TransferLineInsertFromBarcode;
    formVars.warehousetransferdetail_251937_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].barcode
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].barcode
          : null
      );
    formVars.warehousetransferdetail_174934_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].itemCode
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].itemCode
          : null
      );
    formVars.warehousetransferdetail_650156_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].itemDescription
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].itemDescription
          : null
      );
    formVars.warehousetransferdetail_902974_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].productAtt01Desc
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].productAtt01Desc
          : null
      );
    formVars.warehousetransferdetail_869192_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].productAtt02Desc
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].productAtt02Desc
          : null
      );
    formVars.warehousetransferdetail_780854_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].previousQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].previousQty
          : null
      );
    formVars.warehousetransferdetail_626780_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].newQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].newQty
          : null
      );
    formVars.warehousetransferdetail_657165_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].appliedQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].appliedQty
          : null
      );
    stateVars.isComp263027Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp251937Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp576803Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("BARCODE_NOT_FOUND", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp721759Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp402812Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].operationType
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].operationType
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ADD", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_TransferLineInsertFromBarcode !== undefined
              ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
                ? stateVars.HS_TransferLineInsertFromBarcode[0].result
                : null
              : this.state.HS_TransferLineInsertFromBarcode?.length > 0
              ? this.state.HS_TransferLineInsertFromBarcode[0].result
              : null
          ),
          ReactSystemFunctions.convertToTypeByName(
            "BARCODE_NOT_FOUND",
            "string"
          )
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp530942Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("LINE_NOT_FOUND", "string")
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_TransferLineInsertFromBarcode !== undefined
              ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
                ? stateVars.HS_TransferLineInsertFromBarcode[0].operationType
                : null
              : this.state.HS_TransferLineInsertFromBarcode?.length > 0
              ? this.state.HS_TransferLineInsertFromBarcode[0].operationType
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("REMOVE", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848234Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp695618Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp367813Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp358223Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp98875Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_TransferLineInsertFromBarcode !== undefined
            ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
              ? stateVars.HS_TransferLineInsertFromBarcode[0].result
              : null
            : this.state.HS_TransferLineInsertFromBarcode?.length > 0
            ? this.state.HS_TransferLineInsertFromBarcode[0].result
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SUCCESS", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_131297_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_131297_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.warehousetransferdetail_251937_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].barcode
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].barcode
          : null
      );

    formVars.warehousetransferdetail_174934_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].itemCode
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].itemCode
          : null
      );

    formVars.warehousetransferdetail_650156_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].itemDescription
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].itemDescription
          : null
      );

    formVars.warehousetransferdetail_902974_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].productAtt01Desc
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].productAtt01Desc
          : null
      );

    formVars.warehousetransferdetail_869192_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].productAtt02Desc
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].productAtt02Desc
          : null
      );

    formVars.warehousetransferdetail_780854_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].previousQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].previousQty
          : null
      );

    formVars.warehousetransferdetail_626780_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].newQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].newQty
          : null
      );

    formVars.warehousetransferdetail_657165_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_TransferLineInsertFromBarcode !== undefined
          ? stateVars.HS_TransferLineInsertFromBarcode?.length > 0
            ? stateVars.HS_TransferLineInsertFromBarcode[0].appliedQty
            : null
          : this.state.HS_TransferLineInsertFromBarcode?.length > 0
          ? this.state.HS_TransferLineInsertFromBarcode[0].appliedQty
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_881307_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "warehousetransferdetail_196727_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "warehousetransferdetail_550531_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "warehousetransferdetail_22731_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_881307_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_881307_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemCode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_881307_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItem = result?.data.getItem;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_881307_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_881307_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_576320 = stateVars.GetItem ?? this.state.GetItem;
    formVars.warehousetransferdetail_196727_total = ReactSystemFunctions.value(
      this,
      stateVars.GetItem !== undefined
        ? stateVars.GetItem?.length > 0
          ? stateVars.GetItem[0].totalRowCount
          : null
        : this.state.GetItem?.length > 0
        ? this.state.GetItem[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_60849_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "warehousetransferdetail_196727_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_60849_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_60849_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_550531_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_22731_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_60849_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItem = result?.data.getItem;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_60849_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_60849_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_576320 = stateVars.GetItem ?? this.state.GetItem;
    formVars.warehousetransferdetail_196727_total = ReactSystemFunctions.value(
      this,
      stateVars.GetItem !== undefined
        ? stateVars.GetItem?.length > 0
          ? stateVars.GetItem[0].totalRowCount
          : null
        : this.state.GetItem?.length > 0
        ? this.state.GetItem[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_222296_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "WarehouseTransferAddManuelItemPop",
      "ItemId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "warehousetransferdetail_576320_value",
          "id"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "WarehouseTransferDetail",
      "WarehouseTransferAddManuelItemPop",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "27071",
      null,
      null,
      "true",
      "100%",
      "400px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_196727_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_550531_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_22731_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_196727_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_196727_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItem = result?.data.getItem;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_196727_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_196727_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_576320 = stateVars.GetItem ?? this.state.GetItem;
    formVars.warehousetransferdetail_196727_total = ReactSystemFunctions.value(
      this,
      stateVars.GetItem !== undefined
        ? stateVars.GetItem?.length > 0
          ? stateVars.GetItem[0].totalRowCount
          : null
        : this.state.GetItem?.length > 0
        ? this.state.GetItem[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_594209_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TransferHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      SearchItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_594209_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTransferLineByHeader = result?.data.getTransferLineByHeader;

    stateVars.isComp943807Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTransferLineByHeader !== undefined
            ? stateVars.GetTransferLineByHeader?.length > 0
              ? stateVars.GetTransferLineByHeader[0].erpDocumentNo
              : null
            : this.state.GetTransferLineByHeader?.length > 0
            ? this.state.GetTransferLineByHeader[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_594209_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_594209_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_633835 =
      stateVars.GetTransferLineByHeader ?? this.state.GetTransferLineByHeader;
    formVars.warehousetransferdetail_355611_total = ReactSystemFunctions.value(
      this,
      stateVars.GetTransferLineByHeader !== undefined
        ? stateVars.GetTransferLineByHeader?.length > 0
          ? stateVars.GetTransferLineByHeader[0].totalRowCount
          : null
        : this.state.GetTransferLineByHeader?.length > 0
        ? this.state.GetTransferLineByHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_887885_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "warehousetransferdetail_301750_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "warehousetransferdetail_750687_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "warehousetransferdetail_355611_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_887885_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_887885_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TransferHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      SearchItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_887885_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTransferLineByHeader = result?.data.getTransferLineByHeader;

    stateVars.isComp943807Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTransferLineByHeader !== undefined
            ? stateVars.GetTransferLineByHeader?.length > 0
              ? stateVars.GetTransferLineByHeader[0].erpDocumentNo
              : null
            : this.state.GetTransferLineByHeader?.length > 0
            ? this.state.GetTransferLineByHeader[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_887885_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_887885_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_633835 =
      stateVars.GetTransferLineByHeader ?? this.state.GetTransferLineByHeader;
    formVars.warehousetransferdetail_355611_total = ReactSystemFunctions.value(
      this,
      stateVars.GetTransferLineByHeader !== undefined
        ? stateVars.GetTransferLineByHeader?.length > 0
          ? stateVars.GetTransferLineByHeader[0].totalRowCount
          : null
        : this.state.GetTransferLineByHeader?.length > 0
        ? this.state.GetTransferLineByHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_152099_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "warehousetransferdetail_355611_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_152099_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_152099_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TransferHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_301750_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SearchItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_750687_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_152099_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTransferLineByHeader = result?.data.getTransferLineByHeader;

    stateVars.isComp943807Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTransferLineByHeader !== undefined
            ? stateVars.GetTransferLineByHeader?.length > 0
              ? stateVars.GetTransferLineByHeader[0].erpDocumentNo
              : null
            : this.state.GetTransferLineByHeader?.length > 0
            ? this.state.GetTransferLineByHeader[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_152099_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_152099_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_633835 =
      stateVars.GetTransferLineByHeader ?? this.state.GetTransferLineByHeader;
    formVars.warehousetransferdetail_355611_total = ReactSystemFunctions.value(
      this,
      stateVars.GetTransferLineByHeader !== undefined
        ? stateVars.GetTransferLineByHeader?.length > 0
          ? stateVars.GetTransferLineByHeader[0].totalRowCount
          : null
        : this.state.GetTransferLineByHeader?.length > 0
        ? this.state.GetTransferLineByHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_531425_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TransferHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      transferId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      description_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost !== undefined
            ? stateVars.TransferListForPost?.length > 0
              ? stateVars.TransferListForPost[0].description
              : null
            : this.state.TransferListForPost?.length > 0
            ? this.state.TransferListForPost[0].description
            : null
        ),
        "string"
      ),
      officeCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost !== undefined
            ? stateVars.TransferListForPost?.length > 0
              ? stateVars.TransferListForPost[0].officeCode
              : null
            : this.state.TransferListForPost?.length > 0
            ? this.state.TransferListForPost[0].officeCode
            : null
        ),
        "string"
      ),
      warehouseCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost !== undefined
            ? stateVars.TransferListForPost?.length > 0
              ? stateVars.TransferListForPost[0].warehouseCode
              : null
            : this.state.TransferListForPost?.length > 0
            ? this.state.TransferListForPost[0].warehouseCode
            : null
        ),
        "string"
      ),
      toOfficeCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost !== undefined
            ? stateVars.TransferListForPost?.length > 0
              ? stateVars.TransferListForPost[0].toOfficeCode
              : null
            : this.state.TransferListForPost?.length > 0
            ? this.state.TransferListForPost[0].toOfficeCode
            : null
        ),
        "string"
      ),
      toWarehouseCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost !== undefined
            ? stateVars.TransferListForPost?.length > 0
              ? stateVars.TransferListForPost[0].toWarehouseCode
              : null
            : this.state.TransferListForPost?.length > 0
            ? this.state.TransferListForPost[0].toWarehouseCode
            : null
        ),
        "string"
      ),
      lines_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.TransferListForPost),
        "any[]"
      ),
      lines_ItemTypeCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.TransferListForPost?.itemTypeCode
        ),
        "number"
      ),
      lines_ItemCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost?.itemCode
        ),
        "string"
      ),
      lines_ColorCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost?.colorCode
        ),
        "string"
      ),
      lines_ItemDim1Code_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost?.itemDim1Code
        ),
        "string"
      ),
      lines_ItemDim2Code_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost?.itemDim2Code
        ),
        "string"
      ),
      lines_ItemDim3Code_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.TransferListForPost?.itemDim3Code
        ),
        "string"
      ),
      lines_Quantity_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.TransferListForPost?.transferQty
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_531425_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TransferListForPost = result?.data.transferListForPost;
    stateVars.PostTransfer = result?.data.postTransfer;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_531425_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_531425_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        this.state.PostTransfer?.responseMessage
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_531425_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_531425_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.PostTransfer?.isSuccess),
        "1"
      )
    ) {
      const __currentPath = (
        window.location.hash
          ? window.location.hash.replace(/^#/, "").split("?")[0]
          : window.location.pathname.split("?")[0]
      ).toLowerCase();
      if (__currentPath !== "/warehousetransferlist") {
        this.context.setMasterPageInitLoaded(false);
        this.context.setMasterPageRecurringLoaded(false);
        this.context.setShouldTriggerPageInit(true);
      }
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "WarehouseTransferDetail",
        "WarehouseTransferList",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  WarehouseTransferDetailComponent_355611_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      TransferHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchItemCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_301750_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SearchItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_750687_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "warehousetransferdetail_355611_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "WarehouseTransferDetail/WarehouseTransferDetailComponent_355611_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTransferLineByHeader = result?.data.getTransferLineByHeader;

    stateVars.isComp943807Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTransferLineByHeader !== undefined
            ? stateVars.GetTransferLineByHeader?.length > 0
              ? stateVars.GetTransferLineByHeader[0].erpDocumentNo
              : null
            : this.state.GetTransferLineByHeader?.length > 0
            ? this.state.GetTransferLineByHeader[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.WarehouseTransferDetailComponent_355611_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WarehouseTransferDetailComponent_355611_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_633835 =
      stateVars.GetTransferLineByHeader ?? this.state.GetTransferLineByHeader;
    formVars.warehousetransferdetail_355611_total = ReactSystemFunctions.value(
      this,
      stateVars.GetTransferLineByHeader !== undefined
        ? stateVars.GetTransferLineByHeader?.length > 0
          ? stateVars.GetTransferLineByHeader[0].totalRowCount
          : null
        : this.state.GetTransferLineByHeader?.length > 0
        ? this.state.GetTransferLineByHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [963311, 27071] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.WarehouseTransferDetailPageInit();
    }
  }
}
